module.exports = __webpack_public_path__ + "img/error-not-inscreen.ae6a565d.svg";